/**
 * Deep S, intermission 3: three lanes, each with an expanding wall at its mouth that chases you
 * along it. Keep running; the pockets under the lanes are traps unless you snap them
 * (docs/spec/03 §3).
 */

import type { CaveDef } from '../types';

export const deepS: CaveDef = {
  id: 'S',
  name: 'CRAWLSPACE',
  hint: 'Keep running. Snap the side pockets, never step in.',
  intermission: true,
  colors: [4, 15, 1],
  diamondValue: 25,
  extraValue: 35,
  fill: { base: '.', items: [['d', 25], [' ', 15]] },
  levels: [
    { seed: 6901, diamonds: 10, time: 26 },
    { seed: 6902, diamonds: 12, time: 23 },
    { seed: 6903, diamonds: 13, time: 20 },
    { seed: 6904, diamonds: 14, time: 17 },
    { seed: 6905, diamonds: 15, time: 15 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWW',
    'WwPwwwwwwwwwwwwwwwwW',
    'Wx.d??d.d??d.d??d.wW',
    'Wwwwwwwdwwwwwdwww.wW',
    'Wwwwwwwwwwwwwwwww.wW',
    'Wwd??d.d??d.d??d..xW',
    'Ww.wwwwdwwwwwdwwwwwW',
    'Ww.wwwwwwwwwwwwwwwwW',
    'Wx.d??d.d??d.d??d..W',
    'Wwwwwwwdwwwwwdwwww.W',
    'WwwwwwwwwwwwwwwwwwXW',
    'WWWWWWWWWWWWWWWWWWWW',
  ],
};
